import TextTitleCondensed from 'components/TextTitleCondensed.js'
import React from 'react'

export default function TextTitleCompressedLight (props) {
  return (
    <TextTitleCondensed
      fw='270'
      {...props}
    />
  )
}
